import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { PermissionGroup } from "../Model/PermissionGroup";

export async function getPermissionGroup(id) {
	let response = await getAPIResponse("/v1/permission-group/"+id);
	if (response === null) {
		return null;
	}
	let permissionGroup = PermissionGroup.createFromResponseData(response);
	return permissionGroup;
}